import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";

const EduTagAdminPage = lazy(() => import('_deziiign/main/pages/eduTagAdmin'));
const ManageTagPage = lazy(() => import('_deziiign/main/pages/manageTag/ManageTagPage'));
const TagAdminPage = lazy(() => import("_deziiign/main/pages/tagAdmin"));
const TagCategoryView = lazy(() => import('shared/pages/tagCategoryView'));
const TagView = lazy(() => import("shared/pages/tag"));
const TagListPage = lazy(() => import('shared/pages/tagList'));
const TagListCompetenciesPage = lazy(() => import('shared/pages/tagListCompetencies'));
const MainTagAdminPage = lazy(() => import('_deziiign/main/pages/MainTagAdminPage'));

const tagRoutes = [
    { path: LinkTo.tags, exact: true, component: TagListPage },
    { path: [LinkTo.tagCompetencies, LinkTo.categories], exact: true, component: TagListCompetenciesPage },
    { path: LinkTo.tagMainModer, exact: true, component: () => <MainTagAdminPage /> },    
    { path: LinkTo.tagAdmin, exact: true, component: () => <TagAdminPage isExpertModer={false}/> },
    { path: LinkTo.tagExpert, exact: true, component: () => <TagAdminPage isExpertModer={true}/> },
    { path: LinkTo.tagEditor, exact: true, component: () => <TagAdminPage isEditor={true} isExpertModer={false}/> },
    { path: LinkTo.eduTagAdmin, exact: true, component: EduTagAdminPage },
    { path: LinkTo.manageTag, exact: true, component: ManageTagPage },
    { path: LinkTo.manageTag + "/:tagId", exact: true, component: ManageTagPage },
    { path: LinkTo.tagCategory, exact: true, component: TagCategoryView },
    { path: LinkTo.tagCategoryChild, exact: true, component: TagCategoryView },
    { path: LinkTo.tag, exact: true, component: () => <TagView className="witeTheme"/> },
];

export default tagRoutes;import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";

const EduTagAdminPage = lazy(() => import('_deziiign/main/pages/eduTagAdmin'));
const ManageTagPage = lazy(() => import('_deziiign/main/pages/manageTag/ManageTagPage'));
const TagAdminPage = lazy(() => import("_deziiign/main/pages/tagAdmin"));
const TagCategoryView = lazy(() => import('shared/pages/tagCategoryView'));
const TagView = lazy(() => import("shared/pages/tag"));
const TagListPage = lazy(() => import('shared/pages/tagList'));
const TagListCompetenciesPage = lazy(() => import('shared/pages/tagListCompetencies'));
const MainTagAdminPage = lazy(() => import('_deziiign/main/pages/MainTagAdminPage'));

const tagRoutes = [
    { path: LinkTo.tags, exact: true, component: TagListPage },
    { path: [LinkTo.tagCompetencies, LinkTo.categories], exact: true, component: TagListCompetenciesPage },
    { path: LinkTo.tagMainModer, exact: true, component: () => <MainTagAdminPage /> },    
    { path: LinkTo.tagAdmin, exact: true, component: () => <TagAdminPage isExpertModer={false}/> },
    { path: LinkTo.tagExpert, exact: true, component: () => <TagAdminPage isExpertModer={true}/> },
    { path: LinkTo.tagEditor, exact: true, component: () => <TagAdminPage isEditor={true} isExpertModer={false}/> },
    { path: LinkTo.eduTagAdmin, exact: true, component: EduTagAdminPage },
    { path: LinkTo.manageTag, exact: true, component: ManageTagPage },
    { path: LinkTo.manageTag + "/:tagId", exact: true, component: ManageTagPage },
    { path: LinkTo.tagCategory, exact: true, component: TagCategoryView },
    { path: LinkTo.tagCategoryChild, exact: true, component: TagCategoryView },
    { path: LinkTo.tag, exact: true, component: () => <TagView className="witeTheme"/> },
];

export default tagRoutes;